export const siteContent = {
  brandName: "Altera",
  categoryLabel: "Автоматизация контейнерного терминала",
  siteUrl: process.env.GATSBY_SITE_URL || "https://altera-term.ru",
  contactEmail: "sales@altera-term.ru",
  web3formsAccessKey: "d5aa06ff-7745-4ad9-8ae6-3225694e9ca8",
  yandexMetrikaId: 110792244,
  menu: [
    { label: "Продукты", href: "/products/", type: "products" },
    { label: "Для кого", href: "/for-whom/" },
    { label: "Кейсы", href: "/cases/", type: "cases" },
    { label: "Интеграции", href: "/integrations/" },
    { label: "Преимущества", href: "/advantages/" },
    { label: "Блог", href: "/blog/" }
  ],
  hero: {
    title: "Автоматизируем все процессы контейнерной логистики",
    subtitle:
      "Наша миссия: избавить сотрудников от необходимости дублировать информацию в системе вручную. Система должна автоматически оцифровывать все процессы.",
    ctaPrimary: "Запросить демонстрацию",
    ctaSecondary: "Обсудить процессы терминала",
    trustItems: [
      "Интеграция в течение недели",
      "Доработка под процессы площадки",
      "Поддержка и развитие после запуска"
    ]
  },
  audience: [
    {
      title: "Контейнерные депо",
      pain: "Автоматические статусы, ремонты, хранение и постоянные запросы от клиентов",
      modules: ["DEPOT-процессы внутри TOS", "YRD", "AI"]
    },
    {
      title: "Контейнерные линии",
      pain: "Нужны точные статусы, документы и контроль движения контейнеров",
      modules: ["TOS", "RAIL", "AI"]
    },
    {
      title: "Сюрвейеры",
      pain: "Фотофиксация, статусы, акты и прозрачная работа по операциям",
      modules: ["TOS", "CUSTOM", "AI"]
    },
    {
      title: "Экспедиторы",
      pain: "Сложно быстро получать статусы, документы и подтверждения по грузу",
      modules: ["TOS", "AI", "CUSTOM"]
    },
    {
      title: "Перегрузочные терминалы",
      pain: "Ручные документы, отклонения по весу и хаос в операционном учёте",
      modules: ["TOS", "RAIL", "CUSTOM"]
    },
    {
      title: "Площадки с ЖД- и автофронтом",
      pain: "Приём и отправка вагонов, постановка, вес, ЭТРАН и связка с документами",
      modules: ["RAIL", "YRD", "TOS"]
    }
  ],
  pains: [
    "Ручной учёт и Excel вместо одной рабочей системы",
    "Потеря времени на сверки, документы и ежедневные отчёты",
    "Ошибки в постановке контейнеров и лишние перемещения по площадке",
    "Непрозрачные статусы для клиентов, линий и подрядчиков",
    "Разрозненные данные по ЖД, операциям, весу и документам",
    "Страх долгого и дорогого внедрения без понятного первого результата"
  ],
  products: [
    {
      slug: "tos",
      code: "TOS",
      brandCode: "Altera.TOS",
      name: "Приём, выдача, документы, отчёты",
      menuSummary: "Контейнеры, документы, автопарк и операционный учёт в одной системе.",
      description:
        "Приём и выдача контейнеров, генерация документов, перетарка, ремонт, автопарк и отчётность",
      painPoints: [
        "Excel и ручные таблицы вместо одной системы",
        "Документы собираются вручную",
        "По приёмке и выдаче нет единого статуса",
        "Машины, водители и рейсы учитываются отдельно от операций"
      ],
      includes: [
        "Приём контейнеров и груза с помощью распознавания текста и документов",
        "Генерация документов (акты приёма/выдачи, ТТН, VGM и т.д.)",
        "Отчёты и прозрачные статусы для клиентов",
        "Управление автопарком: машины, водители и рейсы",
        "Тарификация и выставление счетов",
        "Интеграция со смежными системами"
      ],
      benefits: [
        "Меньше ручной рутины у операторов",
        "Понятный статус по каждой операции",
        "Быстрее подготовка документов и отчётов",
        "Автопарк и операции в одной системе, а не в отдельной таблице"
      ],
      useCases: [
        "Приём контейнера на площадку",
        "Выдача контейнера клиенту",
        "Сбор ежедневной отчётности",
        "Подготовка документов по операциям",
        "Учёт машин, водителей и рейсов собственного автопарка"
      ],
      integrations: ["1С", "EDI / CODECO", "РОЛИС", "ГосЛог", "Внутренние базы"],
      intakeFlow: {
        eyebrow: "Как работает модуль",
        title: "Как работает приём контейнера",
        description: "От заявки клиента до подтверждённой постановки — без бумажных бланков и повторного ввода данных.",
        steps: [
          {
            title: "Клиент создаёт заявку",
            time: "< 1 минуты",
            description: "Из документа или свободным текстом — заявка на приём готова меньше чем за минуту.",
            optional: {
              title: "Altera.YRD подбирает место",
              description: "Система автоматически назначает контейнеру ячейку на терминале."
            }
          },
          {
            title: "Контейнер прибывает на терминал",
            time: "10–20 секунд",
            description: "Сотрудник фотографирует контейнер — система распознаёт номер и фиксирует въезд по фото.",
            optional: {
              title: "Ричстакер подтверждает постановку",
              description: "Ричстакер устанавливает контейнер на назначенное место и подтверждает операцию в системе."
            }
          },
          {
            title: "Ремонт и дополнительные услуги",
            description: "Полный цикл ремонта: от фиксации повреждений до назначения услуг. Клиент видит и подтверждает смету."
          },
          {
            title: "Тарифы и выставление счетов",
            description: "Управляйте тарифами и выставляйте счета клиентам по фактически оказанным услугам."
          }
        ]
      },
      cargoFlow: {
        eyebrow: "Как работает модуль",
        title: "Управляйте грузом от приёмки до выставления счёта",
        description: "Прием груза, входной контроль, перетарка, подготовка документов, автоматические заявки на выдачу, тарификация и выставление счёта.",
        steps: [
          {
            title: "Сотрудник вносит грузовые единицы",
            description: "Пачкой, из документа или свободным текстом — без ручного набора по одной позиции."
          },
          {
            title: "Система распознаёт и фиксирует груз",
            description: "Каждая грузовая единица распознаётся и фиксируется в системе автоматически."
          },
          {
            title: "Входной контроль или приёмка на терминал",
            description: "Можно назначить входной контроль перед приёмкой или сразу принять груз на терминал.",
            choices: ["Входной контроль", "Прямая приёмка"]
          },
          {
            title: "Перетарка",
            description: "Система автоматически считает расчёты исходя из типа груза, тары и фактических данных."
          },
          {
            title: "Подготовка документов",
            description: "ТТН, отчёты, акты затарки и VGM формируются автоматически, без ручного заполнения бланков."
          },
          {
            title: "Автоматические заявки на выдачу",
            description: "Заявки на выдачу гружёных контейнеров формируются системой на основе фактических данных.",
            optional: {
              title: "Интеграция со смежными системами",
              description: "Например РОЛИС — для заявок на завоз контейнеров в порт."
            }
          },
          {
            title: "Тарификация и выставление счёта",
            description: "Стоимость услуг по работе с грузом фиксируется автоматически, счёт выставляется клиенту."
          }
        ]
      }
    },
    {
      slug: "yrd",
      code: "YRD",
      brandCode: "Altera.YRD",
      name: "Адресное хранение и постановка",
      menuSummary: "Автоматическое планирование, камеры и динамические правила постановки.",
      description:
        "Адресное хранение с автоматическим планированием, динамическими правилами постановки и контролем лифтовых операций.",
      painPoints: [
        "Контейнеры сложно быстро найти на площадке",
        "Постановка зависит от людей и ручных решений",
        "Лишние лифтовые операции увеличивают потери"
      ],
      includes: [
        "Адресное хранение",
        "Автоматическое планирование размещения",
        "Динамические правила постановки",
        "Интеграция с камерами",
        "Учёт лифтовых операций"
      ],
      benefits: [
        "Меньше лишних перемещений",
        "Быстрее поиск контейнера",
        "Более предсказуемая работа площадки"
      ],
      useCases: [
        "Планирование постановки контейнера",
        "Поиск контейнера по зоне и статусу",
        "Контроль перемещений по площадке",
        "Снижение лишних лифтовых операций"
      ],
      integrations: ["Камеры", "РОЛИС", "Внутренние базы", "TOS"]
    },
    {
      slug: "rail",
      code: "RAIL",
      brandCode: "Altera.RAIL",
      name: "ЖД-модуль и ЭТРАН",
      menuSummary: "ЖД-приём, отправка, вес, документы и постановка вагонов.",
      description:
        "ЖД-модуль для планирования приёма и отправки, фиксации веса, генерации документов и работы с ЭТРАН.",
      painPoints: [
        "Сверки по ЖД и ЭТРАН ведутся вручную",
        "Постановка вагонов и контейнеров плохо планируется",
        "Документы и весовые данные живут отдельно от операций"
      ],
      includes: [
        "Интеграция с ЭТРАН",
        "Планирование приёма и отправки ЖД",
        "Фиксация веса",
        "Генерация документов",
        "Планирование постановки вагонов"
      ],
      benefits: [
        "Быстрее работа ЖД-фронта",
        "Меньше ручных сверок и ошибок",
        "Одна логика для операций и документов"
      ],
      useCases: [
        "Приём контейнерного поезда",
        "Отправка вагонов",
        "Сверка с ЭТРАН",
        "Фиксация веса и документов по ЖД"
      ],
      integrations: ["ЭТРАН", "РОЛИС", "1С", "Весовой контур"]
    },
    {
      slug: "ai",
      code: "AI",
      brandCode: "Altera.AI",
      name: "Чат, аналитика и поддержка",
      menuSummary: "Управление терминалом из чата, аналитика и связка с внешними системами.",
      description:
        "Управление терминалом из чата, быстрый доступ к аналитике и интеграция с внешними системами и поддержкой.",
      painPoints: [
        "Статусы, отчёты и сводки собираются слишком долго",
        "Для простых ответов приходится обращаться к нескольким людям",
        "Поддержка и данные не связаны в один быстрый контур"
      ],
      includes: [
        "Управление терминалом из чата",
        "Операционная аналитика",
        "Интеграция с внешними системами",
        "Поддержка и быстрые ответы"
      ],
      benefits: [
        "Быстрее доступ к данным и статусам",
        "Меньше ручных уточнений",
        "Удобнее контроль ситуации для руководителей и операторов"
      ],
      useCases: [
        "Быстрая проверка статусов по операциям",
        "Сбор сводной аналитики",
        "Уточнение данных из внешних систем",
        "Помощь команде в работе с системой"
      ],
      integrations: ["Внешние системы", "TOS", "ЖД-модуль", "Внутренние базы"]
    },
    {
      slug: "custom",
      code: "CUSTOM",
      brandCode: "Altera.CUSTOM",
      name: "Кастомные модули под ваш процесс",
      menuSummary: "Доработка под нестандартные сценарии и задачи вне типового контура.",
      description:
        "Если типового модуля недостаточно, разрабатываем кастомный блок под конкретный бизнес-процесс и закрываем задачу, которая не вписывается в общий шаблон.",
      painPoints: [
        "Часть процессов не покрывается типовыми модулями",
        "Есть уникальная логика площадки или клиента",
        "Нужна отдельная интеграция или нетиповой сценарий работы"
      ],
      includes: [
        "Кастомные модули",
        "Доработка под бизнес-процесс",
        "Нестандартные интеграции",
        "Специализированные формы, отчёты и сценарии"
      ],
      benefits: [
        "Не нужно ломать процесс под шаблон",
        "Можно закрыть уникальную операционную задачу",
        "Новая логика встраивается в общую систему"
      ],
      useCases: [
        "Нестандартные правила постановки контейнеров",
        "Кастомные формы документов",
        "Специальная логика согласования",
        "Локальные интеграции с внутренними системами",
        "Отдельные сценарии под линию или клиента"
      ],
      integrations: ["Локальные системы", "1С", "РОЛИС", "Внутренние API клиента"]
    }
  ],
  forWhom: [
    {
      slug: "container-depot",
      title: "Контейнерные депо",
      problem: "Статусы, ремонт, хранение и клиентские запросы часто ведутся вручную.",
      modules: ["TOS", "YRD", "AI"],
      outcome: "Меньше ручной работы, понятный статус контейнера и быстрее работа с клиентами."
    },
    {
      slug: "container-lines",
      title: "Контейнерные линии",
      problem: "Нужны прозрачные статусы, документы и контроль движения контейнеров.",
      modules: ["TOS", "RAIL", "AI"],
      outcome: "Быстрее доступ к данным по операциям и меньше ручных уточнений."
    },
    {
      slug: "surveyors",
      title: "Сюрвейеры",
      problem: "Нужно фиксировать состояние контейнера, документы и результаты осмотров в одном месте.",
      modules: ["TOS", "CUSTOM", "AI"],
      outcome: "Меньше разрозненных данных и быстрее подготовка итоговых материалов."
    },
    {
      slug: "freight-forwarders",
      title: "Экспедиторы",
      problem: "Слишком много ручных запросов по статусам, документам и фактическому движению контейнера.",
      modules: ["TOS", "AI", "CUSTOM"],
      outcome: "Быстрее ответы клиентам и меньше зависимости от ручных уточнений."
    },
    {
      slug: "transshipment-terminals",
      title: "Перегрузочные терминалы",
      problem: "ПРР, документы, вес и учёт операций часто живут в разных местах.",
      modules: ["TOS", "RAIL", "CUSTOM"],
      outcome: "Одна рабочая логика для операций, документов и контроля результатов."
    },
    {
      slug: "rail-truck-terminals",
      title: "Площадки с ЖД- и автофронтом",
      problem: "Сложно синхронизировать ЖД, авто, вес и постановку контейнеров.",
      modules: ["RAIL", "YRD", "TOS"],
      outcome: "Меньше ручных сверок и лучше управляемость на стыке нескольких контуров."
    }
  ],
  cases: [
    {
      slug: "camera-detection",
      title: "Автоматическая фиксация с камер",
      menuSummary: "Приём и выдача контейнеров фиксируются автоматически, без ручного ввода оператора.",
      eyebrow: "Кейс · Камеры",
      description:
        "Освобождаем сотрудника, который вручную дублирует в системе то, что уже произошло на площадке. Системы обнаружения фиксируют заезд, постановку и выезд контейнера сами.",
      painPoints: [
        "Оператор вручную переносит в систему то, что уже случилось на площадке",
        "Между реальным событием и записью в системе всегда есть задержка",
        "Ручной ввод — источник ошибок в номерах, типах и статусах",
        "Нет единого источника правды о том, что фактически происходит на терминале"
      ],
      integrationOptions: [
        {
          title: "Подключаемся к существующим камерам",
          description:
            "Если на площадке уже есть видеонаблюдение или видеоаналитика (например, MacroscoP и похожие платформы), интегрируемся с ней и забираем события без замены оборудования."
        },
        {
          title: "Совместно устанавливаем камеры",
          description:
            "Если готовой инфраструктуры нет, подбираем и монтируем камеры под нужные точки контроля: въезд, выезд, зона приёма и постановки."
        }
      ],
      flows: [
        {
          title: "Автоматический приём контейнера",
          steps: [
            { title: "Контейнер въезжает на терминал", description: "Камера фиксирует факт въезда и запускает распознавание." },
            {
              title: "Распознаём, фиксируем и фотографируем",
              description:
                "Номер контейнера, тип и размер (20/40 ft), состояние и повреждения, номер пломбы, дата и время, авто и госномер, фото со всех сторон — снимки прикрепляются к операции автоматически."
            },
            { title: "Заявка на приём обновляется сама", description: "Оператор только проверяет и подтверждает уже готовые данные." }
          ]
        },
        {
          title: "Автоматическая выдача контейнера",
          steps: [
            { title: "Контейнер подаётся к выезду", description: "Камера фиксирует контейнер и сверяет его с активной заявкой на выдачу." },
            {
              title: "Проверка соответствия и фотофиксация",
              description: "Система сверяет номер, тип и состояние с тем, что должно быть выдано, и фиксирует момент выезда фото и таймстампом."
            },
            { title: "Статус контейнера закрывается", description: "Операция и связанные документы обновляются автоматически." }
          ]
        }
      ],
      benefits: [
        "Меньше людей на ручном вводе операционных данных",
        "Данные в системе синхронны с тем, что происходит на площадке",
        "Меньше ошибок в номерах, типах и статусах",
        "Каждая операция подтверждена фото и точным временем"
      ]
    },
    {
      slug: "terminal-digitization",
      title: "Автоматическая оцифровка терминала",
      menuSummary: "Фактическое состояние площадки автоматически отражается на 3D-визуализации.",
      eyebrow: "Кейс · Цифровой терминал",
      description:
        "Фиксируем фактическое состояние терминала — какие ячейки заняты, что в них стоит — и переносим это на 3D-визуализацию, которая всегда отражает реальную картину площадки.",
      painPoints: [
        "Схема площадки в системе расходится с тем, что реально стоит в бунтах",
        "Руководителю приходится идти на площадку, чтобы понять реальную картину",
        "Планирование постановки строится на устаревших или неточных данных"
      ],
      process: [
        { title: "Создаём цифровую копию терминала", description: "За короткий срок собираем схему бунтов, ячеек и ограничений конкретной площадки." },
        { title: "Состояние ячеек обновляется по событиям", description: "Приём, выдача и перемещение контейнера меняют цифровую схему — вручную или автоматически через кейс «Фиксация с камер»." },
        { title: "3D-визуализация в реальном времени", description: "Свободные, занятые и зарезервированные ячейки видно сразу, без похода на площадку." }
      ],
      benefits: [
        "Видно свободные и занятые ячейки без ручной сверки",
        "Меньше расхождений между системой и фактическим состоянием площадки",
        "Проще планировать постановку и находить контейнер",
        "Руководитель видит терминал удалённо, в реальном времени"
      ],
      relatedDemo: { label: "Демо Altera.YRD — 3D yard", to: "/products/yrd/" }
    },
    {
      slug: "document-generation",
      title: "Генерация документов",
      menuSummary: "Документы формируются из операционных данных автоматически, без ручного заполнения бланков.",
      eyebrow: "Кейс · Документы",
      description:
        "Модули формируют документы на основе того, что уже зафиксировано в системе, — без переноса данных в бланки вручную.",
      painPoints: [
        "Документы собираются вручную из разных источников",
        "Одни и те же данные переносятся в несколько форм",
        "Ошибки при заполнении задерживают приём, выдачу и сверки"
      ],
      documents: [
        { title: "Акт приёма контейнера", description: "Формируется по данным приёмки: номер, состояние, пломба, дата и время." },
        { title: "Акт выдачи контейнера", description: "Фиксирует факт и условия выдачи клиенту или перевозчику." },
        { title: "Акт осмотра и дефектовки", description: "Повреждения, фото и заключение по состоянию контейнера." },
        { title: "Накладная / ТТН", description: "Транспортные документы на основе данных по авто и грузу." },
        { title: "Документы для ЭТРАН", description: "Комплект по вагонам и контейнерам для ЖД-модуля Altera.RAIL." },
        { title: "Отчёт по операциям за смену/период", description: "Сводка приёмов, выдач и перемещений за выбранный период." },
        { title: "Акт сверки по контрагенту", description: "Сверка операций и статусов с линией, клиентом или подрядчиком." }
      ],
      benefits: [
        "Документ готов сразу после операции, без отдельного шага",
        "Один источник данных — меньше расхождений между документами",
        "Единый шаблон вместо разрозненных файлов у разных сотрудников"
      ]
    },
    {
      slug: "photo-detection",
      title: "Автоматическая фиксация по фото",
      menuSummary: "Сотрудник делает фото — данные распознаются и заносятся в систему автоматически.",
      eyebrow: "Кейс · Фото",
      description:
        "Сотрудник при приёме делает фото контейнера и машины — вся информация автоматически распознаётся и заносится в систему с точностью 99,9%.",
      painPoints: [
        "Не на каждой площадке есть стационарные камеры для автоматической фиксации",
        "Ручной ввод номеров контейнера и авто занимает время и даёт ошибки",
        "Оператору приходится помнить и переносить много деталей вручную"
      ],
      flow: {
        title: "Приём по фото",
        steps: [
          { title: "Фото контейнера и машины", description: "Сотрудник делает снимки прямо с телефона или планшета в момент приёма." },
          {
            title: "Распознавание и черновик заявки",
            description: "Номер контейнера, типоразмер, номер пломбы и госномер авто распознаются системой и сразу подставляются в заявку или акт."
          },
          { title: "Подтверждение оператором", description: "Оператор проверяет распознанные данные и подтверждает — итоговое решение остаётся за человеком." }
        ]
      },
      comparisonNote:
        "Отличие от кейса «Автоматическая фиксация с камер»: там стационарные камеры фиксируют событие без участия человека, здесь — точечное фото по действию сотрудника, когда стационарных камер на площадке ещё нет.",
      benefits: [
        "Точность распознавания 99,9%",
        "Не нужно вручную вбивать номера контейнера и авто",
        "Приём проходит быстрее без потери контроля",
        "Фотодоказательства сохраняются автоматически вместе с операцией"
      ],
      relatedProduct: { label: "Altera.AI — приём из фото и текста", to: "/products/ai/" }
    },
    {
      slug: "data-import",
      title: "Импорт данных из любого документа",
      menuSummary: "Минимум форм, вносите данные по фото или по документу",
      eyebrow: "Кейс · Импорт данных",
      description:
        "Минимум форм — вносите данные по фото или по документу. Вместо того чтобы вручную заполнять десятки полей, загружаете документ, а система сама превращает его в готовые данные.",
      painPoints: [
        "Оператор вручную заполняет одну и ту же форму заявки поле за полем",
        "Данные от клиента уже есть в Excel, PDF или на фото — но всё равно перепечатываются руками",
        "Ошибки в номерах, датах и госномерах при ручном наборе задерживают приём"
      ],
      formFields: [
        "Номер заявки",
        "Дата и время заезда",
        "Компания-перевозчик",
        "Госномер тягача",
        "Госномер прицепа",
        "ФИО водителя",
        "Телефон водителя",
        "Номер контейнера",
        "Тип и размер контейнера",
        "Номер пломбы",
        "Вес брутто",
        "Тип груза",
        "Пункт назначения",
        "Номер заказа клиента",
        "Особые отметки"
      ],
      formTimeNote: "В среднем заполнение такой формы вручную занимает 5–7 минут на одну заявку. Каждая минута стоит денег",
      importFlow: {
        title: "Как это работает",
        steps: [
          { title: "Загружаете документ", description: "Excel, PDF или фото — например список машин от клиента, который должны заехать на терминал." },
          { title: "Система распознаёт данные", description: "Номера, даты, компании и другие поля извлекаются из документа автоматически." },
          { title: "Получаете готовую таблицу", description: "Данные сразу превращаются в редактируемую таблицу — остаётся проверить и подтвердить." }
        ]
      },
      importExample: {
        sourceLabel: "client-trucks.xlsx",
        sourceNote: "Список машин от клиента на завтрашний завоз",
        columns: ["Госномер тягача", "Водитель", "Компания", "Дата и время заезда", "Груз"],
        rows: [
          ["А 412 ХК 178", "Сергеев И. П.", "ТрансЛогистик", "16.07 08:30", "Стройматериалы"],
          ["М 077 ТТ 47", "Кузнецов Д. А.", "СеверАвто", "16.07 09:15", "Металлопрокат"],
          ["Е 233 РМ 178", "Валиев Р. Ш.", "ТрансЛогистик", "16.07 10:00", "Оборудование"],
          ["К 890 ВВ 98", "Орлов С. С.", "БалтКарго", "16.07 11:45", "Стройматериалы"]
        ]
      },
      benefits: [
        "Выше пропускная способность на терминале. Заявка формируется за секунды вместо 5–7 минут ручного набора",
        "Не нужно вручную переносить данные из Excel, PDF или фото",
        "Меньше ошибок в номерах, датах и госномерах",
        "Готовую таблицу легко проверить и отредактировать перед подтверждением"
      ]
    },
    {
      slug: "container-sales",
      title: "Продажа и аренда контейнеров",
      menuSummary: "Оценка, коммерческие предложения, тарификация и публичный список контейнеров — в одном модуле.",
      eyebrow: "Кейс · Продажа и аренда",
      description:
        "Модуль в составе Altera.TOS для терминалов, которые продают или сдают в аренду контейнеры: от оценки состояния до публичной страницы с доступными контейнерами.",
      painPoints: [
        "Стоимость и состояние контейнера оцениваются вручную и по-разному от сделки к сделке",
        "КП и сопутствующие документы каждый раз собираются заново в отдельных файлах",
        "Тарификация и счета считаются отдельно от операционных данных по контейнеру",
        "Нет единого места, где клиент может увидеть, что вообще есть в наличии"
      ],
      capabilities: [
        {
          title: "Стоимость и оценка состояния",
          description: "Модуль помогает выставить стоимость контейнера и зафиксировать оценку состояния по данным, уже накопленным в системе."
        },
        {
          title: "Генерация КП и документов",
          description: "Коммерческое предложение на продажу и сопутствующие документы формируются автоматически из карточки контейнера."
        },
        {
          title: "Тарификация и выставление счетов",
          description: "Счета и тарифы на продажу или аренду считаются на основе тех же операционных данных, без переноса в отдельную таблицу."
        },
        {
          title: "Публичная страница с контейнерами",
          description: "Список контейнеров, доступных для продажи, публикуется на отдельной странице — клиент видит актуальное наличие без звонка в офис."
        }
      ],
      flow: [
        {
          title: "Принимаете контейнер",
          description: "Контейнер принимается по заявке — фиксируете его состояние и отмечаете доступность для аренды или продажи."
        },
        {
          title: "Клиент смотрит наличие",
          description: "Клиенты видят список доступных контейнеров и публичную информацию по каждому: стоимость, характеристики, фото.",
          optional: {
            title: "Настраиваемая публичность",
            description: "Вы сами решаете, какую информацию по контейнеру показывать публично, а какую оставить только для внутренней работы."
          }
        },
        {
          title: "Генерируете КП",
          description: "Коммерческое предложение для клиента формируется автоматически из карточки контейнера."
        },
        {
          title: "Выдаёте контейнер",
          description: "Завершаете сделку и выдаёте контейнер клиенту — статус и операционные данные обновляются сами."
        }
      ],
      relatedProduct: { label: "Altera.TOS", to: "/products/tos/" }
    }
  ],
  integrationItems: ["1С", "EDI / CODECO", "ЭТРАН", "РОЛИС", "ГосЛог"],
  integrationDetails: [
    {
      title: "1С",
      description: "Связка операций терминала с бухгалтерией: документы и взаиморасчёты формируются из фактических данных, без двойного ввода.",
      capabilities: [
        "Выставление счетов по операциям",
        "Формирование актов выполненных работ",
        "Синхронизация справочников контрагентов и договоров",
        "Передача взаиморасчётов и оплат",
        "Выгрузка операций для бухгалтерского учёта"
      ]
    },
    {
      title: "EDI / CODECO",
      description: "Обмен статусами и операционными сообщениями с внешними участниками логистической цепочки."
    },
    {
      title: "ЭТРАН",
      description: "Связка ЖД-процессов, документов и сверок с rail-модулем."
    },
    {
      title: "РОЛИС",
      description: "Заявки в порт. Актуальная сетка НУТЭП."
    },
    {
      title: "ГосЛог",
      description: "Генерация и отправка электронных ТТН через операторов ЭДО/ЭПД в ГИС ЭПД и ГосЛог — без бумажных бланков и ручного дублирования данных."
    }
  ],
  rolloutSteps: [
    {
      title: "Первый контакт / демо",
      description: "Разбираем задачу, показываем подход и понимаем, какой модуль даст первый заметный результат."
    },
    {
      title: "Составляем план внедрения",
      description: "Определяем первый модуль, нужные интеграции, порядок запуска и точки доработки."
    },
    {
      title: "Запуск системы + доработки",
      description: "Подключаем рабочий модуль и адаптируем его под реальные процессы площадки."
    },
    {
      title: "Поддержка",
      description: "Сопровождаем запуск, вносим изменения и добавляем новые модули по мере роста задачи."
    }
  ],
  reliability: [
    {
      title: "SLA",
      description: "Фиксируем правила поддержки и скорость реакции на инциденты."
    },
    {
      title: "Защита данных",
      description: "Контролируем доступ, храним операционные данные и ограничиваем риски утечек."
    },
    {
      title: "Резервные копии",
      description: "Регулярное резервное копирование и сценарии восстановления."
    },
    {
      title: "Разрешённые технологии",
      description: "Используем контролируемый стек и прозрачные подходы к интеграциям."
    },
    {
      title: "Автоматизированные тесты и релизы",
      description: "Стабильные релизы и меньше риска сломать работающий процесс."
    },
    {
      title: "История действий в системе",
      description: "Все действия в системе логируются — можно восстановить любую информацию."
    }
  ],
  advantages: [
    {
      title: "Быстрая интеграция в течение 1-2 недель",
      description: "Не растягиваем подключение на месяцы, если задача понятна и контур определён."
    },
    {
      title: "Быстрая поддержка и разработка",
      description: "Команда быстро реагирует на доработки, вопросы и изменения в процессах терминала."
    },
    {
      title: "Новые модули в среднем за неделю",
      description: "Если задача не покрывается типовым функционалом, мы быстро собираем нужный блок."
    },
    {
      title: "Надёжная инфраструктура",
      description: "Решение строится на стабильной инфраструктуре с контролем данных и резервированием."
    },
    {
      title: "Управляйте всеми процессами с помощью ИИ",
      description: "От внесения клиента в систему по файлу договора до приёма контейнеров по фото."
    }
  ],
  blogPosts: [
    {
      slug: "goslog-electronic-ttn",
      category: "Регулирование",
      title: "Переход на ГосЛог и электронные ТТН с 1 сентября 2026 года",
      summary: "Что такое ГосЛог, зачем он нужен, как к нему технически подключиться и что меняется в процессе выдачи груза на терминале.",
      date: "2026-07-18",
      image: "/blog/goslog-electronic-ttn.png",
      body: [
        "С 1 сентября 2026 года электронная транспортная накладная (ЭТрН) становится единственно допустимой формой для большинства коммерческих автоперевозок — это прямая норма [140-ФЗ от 07.06.2025](https://rosperevozki.ru/blog/etrn-elektronnaya-transportnaya-nakladnaya-2026/). Для терминалов это не смена одного бланка на другой, а перестройка процесса выдачи и приёма груза: подписание, хранение и передача документа государству теперь происходят на каждом рейсе, а не только там, где раньше требовали бумажную ТТН.",
        { heading: "Что такое ГосЛог" },
        "[ГосЛог](https://mintrans.gov.ru/activities/297/367) — Национальная цифровая транспортно-логистическая платформа, государственная информационная система, которую курирует Минтранс России. Это не отдельный документооборот, а надстройка над существующей системой электронных перевозочных документов (ГИС ЭПД): ГосЛог собирает данные о рейсах, реестры участников рынка — перевозчиков, экспедиторов, грузовладельцев — и предоставляет к ним доступ контролирующим органам, включая ФНС и ФТС.",
        "Оператором платформы выступает Минтранс, а сама она построена как единое цифровое пространство, куда стягиваются сервисы, которые раньше были разрознены между разными ведомствами и коммерческими операторами ЭДО.",
        { heading: "Зачем это делают" },
        "Заявленная цель — свести взаимодействие бизнеса и государства в логистике к «одному окну»: одна точка входа вместо отдельных отчётов в разные ведомства, электронный документооборот вместо бумажных ТТН и путевых листов, и прозрачность движения груза для контроля вместо выборочных проверок на дороге.",
        "Для терминала это означает: то, что сейчас фиксируется в собственной TOS или в Excel, а потом отдельно оформляется бумагой для водителя, придётся приводить к формату, который понимает государственная система — с подписями, титулами и обязательной отправкой данных, а не просто печатью бланка.",
        { heading: "Правовая база" },
        {
          list: [
            "[Федеральный закон № 140-ФЗ от 07.06.2025](https://rosperevozki.ru/blog/etrn-elektronnaya-transportnaya-nakladnaya-2026/) — вводит ЭТрН как обязательную форму для большинства коммерческих автоперевозок с 1 сентября 2026 года.",
            "[Постановление Правительства РФ № 139](https://astral.ru/aj/elem/polozhenie-o-platforme-goslog/) — утверждает положение о платформе ГосЛог: её функции, порядок работы и участников.",
            "[Статья 2.6 закона о транспортно-экспедиционной деятельности](https://www.consultant.ru/document/cons_doc_LAW_43006/53975a76528c29ad0a8998b4f74f2884978360d2/) — закрепляет ГосЛог как национальную цифровую транспортно-логистическую платформу и обязательность [реестра экспедиторов с 1 мая 2026 года](https://cargotime.ru/useful/goslog-chto-eto-takoe-i-pochemu-tysyachi-ekspeditorov-riskuyut-poteryat-klientov): без записи в реестре оказывать экспедиторские услуги будет нельзя."
          ]
        },
        { heading: "Что входит в платформу" },
        "ГосЛог объединяет [12 сервисов](https://mintrans.gov.ru/activities/297/367), сгруппированных по функциональному принципу: реестры участников рынка, цифровой транспортный паспорт и цифровой паспорт перевозки, сервисы прослеживаемости грузов, расчёт вариантов маршрута с учётом дорожной обстановки, мониторинг приоритетной доставки социально значимых грузов и интеграцию с внешними системами — в том числе с зарубежными логистическими платформами LOGINK (Китай) и ULIP (Индия).",
        "Для терминала из всего этого напрямую важны три вещи: реестр участников (в нём нужно быть, чтобы работать легально), цифровой паспорт перевозки, который формируется на основе ЭТрН, и прослеживаемость — то есть фактически статус каждого рейса, видимый государству в реальном времени.",
        { heading: "Как это устроено технически" },
        "Терминал не подключается к ГосЛог напрямую. [Схема трёхуровневая](https://astral.ru/aj/elem/integratsiya-epd-cherez-api-bez-otdelnogo-interfeysa-i-slozhnoy-razrabotki/): ваша TOS или WMS передаёт данные оператору ЭДО/ЭПД (аккредитованному Минтрансом посреднику вроде Диадока, СБИС, Такскома или Астрала), тот отправляет документ в государственную систему ГИС ЭПД, а уже оттуда данные о рейсе синхронизируются в ГосЛог. Отдельная регистрация вашей компании в ГИС ЭПД не нужна — достаточно договора с оператором.",
        "Сам документ ЭТрН состоит из [титулов](https://rosperevozki.ru/blog/etrn-elektronnaya-transportnaya-nakladnaya-2026/): Т1 и Т2 подписывают грузоотправитель и перевозчик на погрузке, Т3 и Т4 — перевозчик и получатель на выгрузке. Есть опциональные Т5–Т8 для изменения цены, адреса, водителя или машины в процессе рейса. У подписей разный уровень: водитель на терминале подписывает простой электронной подписью по машиночитаемой доверенности прямо в мобильном приложении оператора, без токена, а юридическое лицо на своей стороне — усиленной квалифицированной подписью (УКЭП) в личном кабинете. Физлица, если участвуют в цепочке, подписывают через Госключ.",
        "Технически [интеграция для терминала](https://astral.ru/aj/elem/integratsiya-epd-cherez-api-bez-otdelnogo-interfeysa-i-slozhnoy-razrabotki/) — это подключение к API оператора ЭДО, а не к самому ГосЛог. Публичная спецификация API самой платформы ГосЛог на момент публикации ещё не раскрыта — Минтранс анонсирует её в течение 2026 года, поэтому практическая интеграция сейчас строится через операторов ЭПД, а не напрямую.",
        { heading: "Сценарий: выдача контейнера с терминала" },
        "На практике для терминала это выглядит как последовательность из пяти шагов, где ваша система — источник данных, а не источник истины: истина по документу хранится в ГИС ЭПД.",
        {
          flow: {
            steps: [
              {
                title: "Диспетчер формирует Т3 в TOS",
                description: "Указывает номер контейнера, рейс, перевозчика и машину — черновик титула автоматически уходит оператору ЭДО через API."
              },
              {
                title: "Оператор ЭДО маршрутизирует документ",
                description: "Проверяет формат, направляет титул в ГИС ЭПД и связывает его с профилем перевозчика, даже если тот работает через другого оператора."
              },
              {
                title: "Водитель подписывает Т3 на терминале",
                description: "Простой ЭП по машиночитаемой доверенности в мобильном приложении оператора — токен не нужен, подпись формируется на месте."
              },
              {
                title: "Получатель подписывает Т4",
                description: "УКЭП руководителя или уполномоченного сотрудника — сразу после Т3, обычно на выгрузке или в момент передачи груза."
              },
              {
                title: "Документ уходит в ГИС ЭПД и ГосЛог",
                description: "Рейс закрывается в государственной системе, документ хранится 5 лет, статус доступен ФНС и ФТС."
              }
            ]
          }
        },
        "Что видит сотрудник терминала в этот момент: в TOS статус контейнера меняется на «выдано перевозчику» сразу после Т3 и на «рейс закрыт» после Т4 — это приходит обратным событием через API оператора, без ручного обновления карточки. Все стороны — грузоотправитель, перевозчик, получатель, экспедитор, если он участвует, — получают PDF документа в своих личных кабинетах у операторов ЭДО, даже если работают через разных провайдеров. [ФНС получает автоматический доступ](https://rosperevozki.ru/blog/etrn-elektronnaya-transportnaya-nakladnaya-2026/) к документу в ГИС ЭПД для налогового контроля, а данные о рейсе — статус, паспорт перевозки — становятся видны в реестрах ГосЛог.",
        "Ключевое отличие от бумажной ТТН: раньше сотрудник терминала выдавал груз и печатал документ, который затем существовал только в физическом виде и в вашей внутренней базе. Теперь то же действие обязано синхронно порождать событие в трёх системах — вашей, у оператора ЭДО и в ГИС ЭПД — и расхождение между ними становится не внутренней проблемой учёта, а поводом для вопросов от контролирующего органа.",
        { heading: "Что с этим делать терминалу уже сейчас" },
        "До 1 сентября 2026 года стоит закрыть три вещи: убедиться, что генерация документов на площадке уже привязана к операционным данным, а не собирается вручную из разных источников — это описано в кейсе [«Генерация документов»](/cases/document-generation/), где Т3/Т4 и накладная формируются автоматически по данным приёмки и выдачи; выбрать оператора ЭДО и завести с ним техническую интеграцию заранее, а не в последний месяц перед обязательным переходом; и, если процесс на площадке нестандартный — например, несколько ролей в цепочке подписания или нетиповая схема выдачи, — заложить время на доработку под конкретный сценарий.",
        "В [Altera.TOS](/products/tos/) генерация ЭТрН строится на тех же данных, что уже зафиксированы при приёме и выдаче контейнера, — без повторного ввода. А там, где процесс выдачи на терминале отличается от типового (свой порядок подписания, дополнительная роль в цепочке, специфика по видам груза), закрываем это отдельным модулем через [Altera.CUSTOM](/products/custom/), не трогая основной контур системы."
      ]
    },
    {
      slug: "saas-vs-custom-ai-solutions",
      category: "Мнение",
      title: "Почему громоздкие SaaS больше не решают проблемы в логистике",
      summary: "Рынок изменился с приходом ИИ — выгоднее и быстрее делать решение под конкретную проблему.",
      date: "2026-07-10",
      image: "/blog/saas-vs-custom-ai-solutions.png",
      body: [
        "У большинства SaaS для логистики одна и та же болезнь. Продукт растёт вширь, а не вглубь: чем больше у платформы клиентов, тем больше в ней настроек, режимов и чекбоксов, которые нужны кому-то другому и просто мешают вам. Форма заявки на приём разрастается до сорока полей, хотя на вашей площадке заполняется двенадцать. Админка становится квестом, а внедрение — отдельным проектом с интегратором на несколько месяцев.",
        { heading: "Почему TOS для терминалов превращаются в монстров" },
        "С контейнерными TOS та же история, только заметнее. Каждый новый клиент приносит вендору свой процесс приёма, свой набор документов, свою логику постановки в бунт. Вендору выгоднее не переписывать ядро под каждого, а добавить ещё один флаг в настройках, ещё один необязательный шаг в мастере, ещё один тип документа в общий список. За несколько лет так набирается система, где половина экрана — это функции, о существовании которых вы даже не подозреваете.",
        "Отдельная боль — любое изменение под вас идёт через очередь вендора и общий релизный цикл: рискованно менять что-то в продукте, которым пользуются ещё сто других терминалов.",
        { heading: "Это не ошибка вендоров — это нормальная эволюция SaaS" },
        "Здесь не в чем упрекать разработчиков платформы. Чтобы продукт продавался всё большему числу клиентов, он обязан покрывать всё больше сценариев — это и есть механика роста SaaS. Проблема не в решении вендора, а в том, что вы — не первый и не единственный клиент, а один из тысячи, и ваш процесс похоронен под процессами всех остальных.",
        { heading: "Как мы в Altera решаем эту проблему" },
        "Модель [Altera.CUSTOM](/products/custom/) устроена иначе: вместо одного огромного ядра «на все случаи» мы строим набор небольших модулей под конкретный бизнес-сценарий терминала, которые не трогают контур остальных клиентов.",
        "Это стало возможно благодаря тому, как изменилась разработка. Раньше написание отдельного экрана с формой, валидацией и связкой с базой данных занимало у команды дни на рутину и только потом — часы на саму бизнес-логику. Сейчас рутинную часть — каркас формы, проверки, типовые запросы к данным — берёт на себя ИИ-инструментарий разработки, и команда сразу занимается тем, что реально отличает ваш процесс от чужого.",
        "Поэтому вместо того чтобы закладывать в ядро продукта ещё один флаг под ваш случай, мы собираем отдельный подмодуль конкретно под него — он живёт в общей системе, использует те же статусы, права доступа и данные, что и остальные модули, но никак не влияет на то, как система работает у другого терминала.",
        "При этом мы не жертвуем ни качеством, ни скоростью поддержки: подмодуль проходит те же проверки и релизный процесс, что и основной продукт — разница только в том, что менять его можно, не оглядываясь на сто других клиентов. В среднем от фиксации требований до готового подмодуля в работе — одна-две недели.",
        { heading: "Где на практике нужен отдельный подмодуль" },
        {
          list: [
            "Более детерминированный процесс приёма с несколькими ролями. На одной площадке в приёме контейнера участвует офис, который оформляет заявку, охранник на КПП, который фиксирует въезд машины, тальман, который составляет акт осмотра, и ричстакер, который подтверждает постановку. Под каждую роль — свой узкий экран: у охранника список ожидаемых машин, у тальмана — форма акта с фото повреждений, у ричстакера — задача на постановку с адресом ячейки. Экраны не пересекаются и не мешают друг другу — это ровно то, что уже устроено в кейсе [«Автоматическая фиксация с камер»](/cases/camera-detection/).",
            "Обратная ситуация — один оператор на весь процесс. На другой площадке весь приём и затарку в смену ведёт один диспетчер при потоке до сотни контейнеров за пару часов. Здесь любой лишний клик или переключение экрана критичны, и подмодуль должен, наоборот, схлопывать процесс в один непрерывный шаг вместо разделения по ролям.",
            "Нестандартное покрытие территории. На площадке с грунтовым покрытием без чёткой разметки строгая адресная сетка ячеек физически не работает — нужен подмодуль, который группирует контейнеры под конкретную партию на отгрузку, а не привязывает их к жёстким координатам."
          ]
        },
        "Общего у этих трёх сценариев одно: ни один типовой TOS не станет держать в ядре продукта одновременно многоролевой процесс, режим одного оператора и группировку без адресной сетки — а мы можем закрыть любой из них отдельным модулем, не трогая остальные."
      ]
    }
  ],
  about: {
    title: "Altera - модульная платформа для терминальных операций",
    description:
      "Сначала запускаем тот модуль, который быстрее всего снимает боль. Затем дорабатываем под процессы площадки и расширяем систему дальше.",
    scope: "TOS, адресное хранение, ЖД-модуль, чат и аналитика, кастомные модули под процесс.",
    outOfScope: "Причальная зона, судозаходы и enterprise-истории полного цифрового порта - отдельный этап или отдельный проект."
  },
  faq: [
    {
      question: "Нам нужен весь TOS сразу?",
      answer: "Нет. Можно начать с одного модуля и закрыть самый проблемный участок, а остальные подключать позже."
    },
    {
      question: "Сколько занимает запуск?",
      answer: "Если задача и интеграции понятны, первый рабочий модуль можно запустить в течение 1-2 недель."
    },
    {
      question: "Что если часть процессов у нас нестандартная?",
      answer: "Для таких случаев есть Altera.CUSTOM - модульная разработка под нетиповой сценарий или уникальный бизнес-процесс. В среднем разработка нового модуля занимает 1-2 недели от анализа до запуска."
    }
  ],
  finalCta: {
    title: "Начните с модуля, который быстрее всего даст результат",
    description:
      "Покажем, с какого участка лучше стартовать, как выглядит план внедрения и какие интеграции нужны именно под ваши процессы.",
    ctaPrimary: "Запросить демонстрацию",
    ctaSecondary: "Обсудить первый модуль"
  },
  seo: {
    title: "Altera - автоматизация контейнерного терминала",
    description:
      "TOS, адресное хранение, ЖД-модуль, управление терминалом из чата и кастомные модули под процессы контейнерного терминала."
  },
  aiPage: {
    hero: {
      eyebrow: "Altera.AI",
      title: "ИИ-ассистент терминала",
      description:
        "Спрашивайте состояние терминала и вносите данные обычным сообщением. Ассистент отвечает по данным ваших модулей и умеет выполнять операции без сложных форм.",
      ctaPrimary: "Запросить демонстрацию",
      ctaSecondary: "Все продукты"
    },
    chat: {
      title: "Altera.AI",
      status: "на связи",
      messages: [
        { from: "user", text: "Сколько за сутки было принято контейнеров?" },
        {
          from: "bot",
          text: "За последние сутки принято 128 контейнеров: 96 на приём и 32 транзитом. Пик загрузки — с 10:00 до 13:00."
        },
        {
          from: "user",
          text: "Создай заявку на приём из этого файла",
          file: "trucks-2024-07.xlsx"
        },
        {
          from: "bot",
          text: "Создал заявку для клиента «ТрансЛогистик» — 14 контейнеров.",
          link: "Открыть заявку →"
        }
      ],
      inputPlaceholder: "Спросите о терминале или дайте команду…"
    },
    capabilities: {
      eyebrow: "Возможности",
      title: "Какие задачи закрывает ассистент",
      items: [
        {
          title: "Быстрая аналитика по терминалу",
          description: "Статусы, сводки и показатели по состоянию площадки — обычным вопросом, без выгрузок и отчётов вручную."
        },
        {
          title: "Ввод данных без сложных форм",
          description: "Заявки, акты и операции создаются из сообщения или файла — ассистент сам подставляет данные в систему."
        },
        {
          title: "Интеграция с внешними системами",
          description: "Ассистент подтягивает и передаёт данные во внешние системы — 1С, ЭТРАН, РОЛИС и другие контуры."
        },
        {
          title: "Права и роли для сотрудников",
          description: "Гибкая настройка доступа: кто может только спрашивать данные, а кто — выполнять операции через чат."
        }
      ]
    },
    architecture: {
      eyebrow: "Архитектура",
      title: "Откуда ассистент берёт информацию",
      description:
        "По умолчанию ассистент работает с данными модулей Altera. Дополнительно его можно подключить к внешним системам терминала.",
      coreLabel: "Altera.AI",
      coreSub: "ассистент",
      userLabel: "Оператор / руководитель",
      branches: [
        {
          label: "Модули Altera",
          note: "по умолчанию",
          tone: "primary",
          nodes: ["TOS", "YRD", "RAIL", "DOC"]
        },
        {
          label: "Внешние системы",
          note: "интеграция",
          tone: "optional",
          nodes: ["1С", "ЭТРАН", "РОЛИС", "EDI / CODECO"]
        }
      ]
    }
  }
};

export function getProductBySlug(slug) {
  return siteContent.products.find((item) => item.slug === slug);
}

export function getCaseBySlug(slug) {
  return siteContent.cases.find((item) => item.slug === slug);
}

export function getPostBySlug(slug) {
  return siteContent.blogPosts.find((item) => item.slug === slug);
}
